/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface UserPermission { 
    readonly id: number;
    codename: string;
    name: string;
    readonly appLabel: string;
    readonly label: string;
}
export const UserPermission_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermission_codename_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(100),];

export const UserPermission_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const UserPermission_appLabel_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPermission_label_Validators: ValidatorFn[] =
    [  Validators.required, ];


